import requests from "./httpService";

const revenueReportServices = {

  getRevenue: async (body) => {
    return requests.post("/revenueReport/", body);
  },

};

export default revenueReportServices;
